module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isloadingUpdate,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isloadingUpdate = $event
      }
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.edit_client_tokens_' + _vm.obj.licenseInfo.byod_type)) + " Mobile auth")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {}, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('b-field', {
    attrs: {
      "label": '* ' + _vm.$t('index.select_configuration_' + _vm.obj.licenseInfo.byod_type)
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select the configuration and room",
      "required": "",
      "expanded": ""
    },
    on: {
      "input": _vm.selectRoom
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.configurationId),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "configurationId", $$v)
      },
      expression: "localTokenVal.editKeyValues.configurationId"
    }
  }, _vm._l((_vm.obj.configurations), function(conf) {
    return _c('option', {
      key: conf.id,
      domProps: {
        "value": conf.id
      }
    }, [_vm._v(_vm._s(conf.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.phone')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-input', {
    directives: [{
      name: "facade",
      rawName: "v-facade",
      value: ('+# (###) ### - ## - ##'),
      expression: "'+# (###) ### - ## - ##'"
    }],
    ref: "legacyInput",
    attrs: {
      "masked": false,
      "type": "text",
      "icon": "phone",
      "placeholder": _vm.$t('index.phone_number')
    },
    nativeOn: {
      "input": function($event) {
        return _vm.onInput($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.comment')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255"
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.comment),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "comment", $$v)
      },
      expression: "localTokenVal.editKeyValues.comment"
    }
  })], 1)], 1)])])]), _vm._v(" "), (_vm.fields.length) ? _c('div', {
    staticClass: "columns is-multiline",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('b-loading', {
    attrs: {
      "is-full-page": false,
      "active": _vm.isLoading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.fields), function(customField, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (customField.edit),
        expression: "customField.edit"
      }],
      key: i,
      staticClass: "column is-half"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s(customField.name))]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('b-field', [_c('b-input', {
      attrs: {
        "type": "text"
      },
      on: {
        "input": function($event) {
          _vm.setCustomValue($event, customField, i)
        }
      },
      model: {
        value: (customField.value),
        callback: function($$v) {
          _vm.$set(customField, "value", $$v)
        },
        expression: "customField.value"
      }
    })], 1)], 1)])])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.cancel')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds has-text-right"
  }, [_c('button', {
    staticClass: "button is-danger",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        _vm.editKey(true)
      }
    }
  }, [_vm._v("Удалить")]), _vm._v(" "), _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        _vm.editKey(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.edit_registration')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-103a41dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/mini_components/Updatemauth.vue
// module id = 298
// module chunks = 2